// Inline SVG sparkline. ~80px wide × 32px tall. Threshold lines drawn as
// faint dashed strokes if the equipment has temp_low_f / temp_high_f set.
export function Sparkline({ points, low, high }) {
  if (!points || points.length < 2) {
    return <div style={{ height: 32, color: '#bdbdbd', fontSize: 11, paddingTop: 8 }}>Not enough data for sparkline</div>;
  }
  const W = 240, H = 36, PAD = 2;
  const vs = points.map(p => Number(p.v)).filter(Number.isFinite);
  const lowVal = low != null ? Number(low) : null;
  const highVal = high != null ? Number(high) : null;
  const minV = Math.min(...vs, lowVal != null ? lowVal : Infinity);
  const maxV = Math.max(...vs, highVal != null ? highVal : -Infinity);
  const range = (maxV - minV) || 1;
  const xStep = (W - 2 * PAD) / (points.length - 1);
  const yFor = (v) => H - PAD - ((v - minV) / range) * (H - 2 * PAD);
  const path = points.map((p, i) => {
    const x = PAD + i * xStep;
    const y = yFor(Number(p.v));
    return `${i === 0 ? 'M' : 'L'}${x.toFixed(1)},${y.toFixed(1)}`;
  }).join(' ');
  const lastV = Number(points[points.length - 1].v);
  const lastInRange = (lowVal == null || lastV >= lowVal) && (highVal == null || lastV <= highVal);
  const stroke = lastInRange ? '#2e7d32' : '#b48a47';
  return (
    <svg width="100%" viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" style={{ display: 'block', marginTop: 4 }}>
      {lowVal != null && (
        <line x1={0} x2={W} y1={yFor(lowVal)} y2={yFor(lowVal)}
          stroke="#b48a47" strokeDasharray="3,2" strokeOpacity="0.35" />
      )}
      {highVal != null && (
        <line x1={0} x2={W} y1={yFor(highVal)} y2={yFor(highVal)}
          stroke="#b48a47" strokeDasharray="3,2" strokeOpacity="0.35" />
      )}
      <path d={path} fill="none" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
